import * as types from './types'

const state = {
  [types.PRODUCT_TO_EDIT]: {},
}

export default state
